import SET_BASE_URL from './types';
export default {
  [SET_BASE_URL](state, payload) {
    const currentState = state;
    currentState.baseURL = payload;
  }

};